import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { DominioCross } from '../../models/entities/dominio-cross';

@Injectable()
export class DominioCrossService {

  resourceUrl = environment.api_rischiocambio_url + restServices.dominioCross;

  constructor(private http: HttpClient) { }

  getDominioCross(): Observable<HttpResponse<DominioCross[]>> {
    return this.http.get<DominioCross[]>(`${this.resourceUrl}`, { observe: 'response' });
  }

  getDominioCrossByCross(cross: string) {
    return this.http.get<DominioCross>(`${this.resourceUrl}/by-cross/${cross}`, { observe: 'response' });
  }
}